// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"585":"b351408c","832":"3cc2d2b1"}[chunkId] + ".chunk.js");